export default __webpack_public_path__ + "static/contact-2-c3a09d9c357c0eafd7c596bf4cb9f84a.jpg";